import { useDispatch, useSelector } from "react-redux";
import LoadingDiv from "../components/LoadingDiv";
import SupportHome from "./SupportHome";
import {
  Camera,
  CheckSquare,
  Clock,
  Package,
  UserCheck,
  UserMinus,
  UserPlus,
  Users,
  Video,
} from "react-feather";
import { useEffect, useState } from "react";

import { Select } from "../components/Inputs";
import moment from "moment";
import { PermissionsHelper } from "../utils/PermissionsHelper";
import { getCameras } from "../state/actions/cameras-actions";
import { Link } from "react-router-dom";
import ContentWrapper from "../components/ContentWrapper";
import Alerts from "../components/Alerts";
import { Config } from "../Config";
const Dashboard = () => {
  const { profileData, loading, cameraData } = useSelector((state) => ({
    profileData: state?.profile?.profileData,
    loading: state?.profile?.loaders?.profile,
    cameraData: state?.cameras?.cameraData,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("_Bearer");
    if (token && profileData?.id) {
      dispatch(getCameras({id:profileData?.id}));
    }
  }, [profileData]);

  const today = new Date();

  const CountDiv = ({ label, icon, value, loading, color, icon_bg, link }) => {
    return (
      <Link
        className="flex justify-between items-start gap-x-4 px-4 py-8 border rounded-xl shadow bg-white"
        to={link ? link : "#"}
      >
        <div className="grid gap-2">
          <p className="font-medium text-gray-800 text-base"> {label} </p>
          <p className="font-bold text-2xl">
            {loading ? (
              <svg
                aria-hidden="true"
                className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            ) : (
              value
            )}
          </p>
        </div>

        <div
          className={`grid items-center ${color ? color : "text-green-600"} -mt-3`}
        >
          <span
            className={`w-12 h-12 rounded-full flex justify-center items-center ${
              icon_bg ? icon_bg : ""
            }`}
          >
            {icon}
          </span>
        </div>
      </Link>
    );
  };

  const ICON_SIZE = 26;

  return loading ? (
    <LoadingDiv />
  ) : (
    <ContentWrapper>
      <div className=" w-full  mx-auto">

        {/* {
         (profileData?.kyc_verified === 0 || profileData?.kyc_verified === null) && */}
         {
          Config?.NodeEnv === "development" &&
          <Alerts kyc_verified={profileData?.kyc_verified} message={
            profileData?.kyc_verified === 0? "KYC Verification Rejected":
            profileData?.kyc_verified === 1? "KYC verified":
            profileData?.kyc_verified === null? "Please Fillup KYC!":"KYC Verification Pending"
            }
            reason={profileData?.rejected_reason}
          />
         }

        {/* } */}
        <div className=" grid lg:grid-cols-4 md:grid-cols-3 xs:grid-cols-1 gap-4">
          <CountDiv
            label={"Total Cameras"}
            value={cameraData?.total}
            icon={<Video size={ICON_SIZE} strokeWidth={2.5} />}
            loading={false}
            color="text-slate-600"
            link={"/cameras"}
          />
        </div>
      </div>
    </ContentWrapper>
  );
};

export default Dashboard;
